import { inject, customAttribute, bindable, bindingMode } from 'aurelia-framework'

@customAttribute('mdx-no-collapse')
@inject(Element)
export class MdxNoCollapseCustomAttribute {
	element: Element;
	constructor(element) {
		this.element = element;
	}

	attached() {
		$(this.element).on("click.collapse", (evt) => {
			evt.stopPropagation();
		});
		
	}
}